<div class="v4-layout-info editing" [formGroup]="form">
  <div class="v4-layout-info-title flex flex-row items-center justify-between">
    <span>{{ "order.check_in_noun" | translate }}</span>
    <div>
      <a
        class="mr-2"
        nz-button
        nzType="link"
        nzSize="small"
        routerLink="/app/properties/detail"
        [queryParams]="{
          id: orderDetail?.house_id,
          title: orderDetail?.house_title,
          subTab: 2
        }">
        {{ "word.set" | translate }}
      </a>
      <!-- <button nz-button nzType="text" nzSize="small">
      </button> -->

      <host-widget-check-guide-menu
        [houseId]="orderDetail?.house_id"
        [code]="orderDetail?.code"
        [completeCheckGuideSetting]="orderDetail?.house_checkin_setting"></host-widget-check-guide-menu>
    </div>
  </div>

  <div class="v4-layout-fields">
    <!-- 到达时间 -->
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        <span> {{ "order.check_in_time_1" | translate }}</span>
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <span>
            {{ orderDetail?.check_in | dateformat: ["YMD"] }}
          </span>
          <host-widget-time-picker
            class="ml-2 flex-1"
            [optionsOfHour]="optionsOfCheckinHour"
            formControlName="check_in_time"></host-widget-time-picker>
        </div>
      </div>
    </div>

    <!-- 退房时间 -->
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        <span>{{ "order.check_out_time_1" | translate }}</span>
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <span>
            {{ orderDetail?.check_out | dateformat: ["YMD"] }}
          </span>
          <host-widget-time-picker
            class="ml-2 flex-1"
            [optionsOfHour]="optionsOfCheckoutHour"
            formControlName="check_out_time"></host-widget-time-picker>
        </div>
      </div>
    </div>

    <!-- 门锁密码 -->
    <div class="v4-layout-field" *ngIf="orderDetail?.guide_info?.lock?.lock_status !== -1">
      <div class="v4-layout-field-label">
        <span>{{ "order.lock_password" | translate }}</span>
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          @if (!isEditingLockPwd) {
            <span>{{ orderDetail?.guide_info?.lock?.lock_password || ("order.lock_unset" | translate) }}</span>

            <button class="ml-2 no-min-width" nz-button nzSize="small" nz-dropdown [nzDropdownMenu]="lockPwdMenu">
              <!-- 设置 -->
              {{ "word.set_lock_pwd" | translate }}
            </button>
            <nz-dropdown-menu #lockPwdMenu="nzDropdownMenu">
              <ul nz-menu nzSelectable [ngSwitch]="orderDetail?.guide_info?.lock?.lock_status">
                <ng-container *ngSwitchCase="0">
                  <li nz-menu-item (click)="onEdit.emit()">
                    <!-- 手动填写 -->
                    {{ "order.input_lock_manually" | translate }}
                  </li>
                  <li nz-menu-item (click)="toCheckinGuidePage()">
                    <!-- 房间入住设置 -->
                    {{ "order.room_checkin_setting" | translate }}
                  </li>
                </ng-container>

                <ng-container *ngSwitchCase="1">
                  <li nz-menu-item (click)="onGenerateLockPW()">
                    <!-- 现在生成 -->
                    {{ "order.now_create" | translate }}
                  </li>
                  <li nz-menu-item (click)="onEdit.emit()">
                    <!-- 手动填写 -->
                    {{ "order.input_lock_manually" | translate }}
                  </li>
                </ng-container>

                <ng-container *ngSwitchCase="2">
                  <li nz-menu-item (click)="onDeleteLockPW()">
                    <!-- 删除密码 -->
                    {{ "order.delete_password" | translate }}
                  </li>
                </ng-container>

                <!-- 固定密码 -->
                <ng-container *ngSwitchCase="3">
                  <li nz-menu-item (click)="toCheckinGuidePage()">
                    <!-- 房间入住设置 -->
                    {{ "order.room_checkin_setting" | translate }}
                  </li>
                </ng-container>
              </ul>
            </nz-dropdown-menu>
          } @else {
            <input class="w-40" type="text" nz-input formControlName="password" hostAutoFocus />
            <div class="flex flex-row">
              <a class="ml-2" nz-button nzType="link" nzSize="small" (click)="onCancelEdit.emit()">
                {{ "word.cancel" | translate }}
              </a>
              <a class="ml-2" nz-button nzType="link" nzSize="small" (click)="onConfirmEditLockPW()">
                {{ "word.save" | translate }}
              </a>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- 密码可见 -->
    <div
      class="v4-layout-field"
      *ngIf="orderDetail?.guide_info !== null && orderDetail?.guide_info?.lock?.lock_status !== -1">
      <div class="v4-layout-field-label">
        <span>{{ "order.password_visible" | translate }}</span>
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <nz-select
            class="flex-1"
            formControlName="visible_password_time"
            [nzOptions]="optionsOfLockPwdVisibleTime"
            [nzCustomTemplate]="visibleTimeTpl">
          </nz-select>
          <ng-template #visibleTimeTpl let-selected>
            <span>{{ "2022-11-11T" + selected.nzLabel | dateformat: [null, "hm"] }}</span>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- 身份登记 -->
    <div
      class="v4-layout-field"
      *ngIf="orderDetail?.guide_info !== null && orderDetail?.guide_info?.need_credential !== -1">
      <div class="v4-layout-field-label">
        <span>{{ "order.identity_registration" | translate }}</span>
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row !w-auto">
          <nz-select
            class="overflow-hidden flex-1"
            formControlName="need_credential"
            [nzDropdownMatchSelectWidth]="false">
            <nz-option [nzLabel]="'house.need_register_and_check' | translate" [nzValue]="1"></nz-option>
            <nz-option [nzLabel]="'house.need_register_and_no_check' | translate" [nzValue]="2"></nz-option>
            <nz-option [nzLabel]="'word.no' | translate" [nzValue]="0"></nz-option>
          </nz-select>
          <!-- 证件数为0时，显示‘上传’，>0时未审核显示‘查看’，已审核显示‘已审核’ -->
          <span *ngIf="orderDetail?.guide_info?.image_count === 0">
            <nz-upload
              *ngIf="listOfCredential?.length < 10"
              nzAction="/api/upload/image"
              [nzShowUploadList]="false"
              [nzBeforeUpload]="beforeUpload"
              [nzAccept]="'image'"
              (nzChange)="onUploadCredentials($event)">
              <button class="ml-2 no-min-width" nz-button nzSize="small">
                <!-- 上传 -->
                {{ "house.orderdetail.upload" | translate }}
              </button>
            </nz-upload>
          </span>

          <a
            class="ml-2"
            nz-button
            nzType="link"
            nzSize="small"
            *ngIf="orderDetail?.guide_info?.image_count > 0"
            (click)="onViewCredentials()">
            {{
              (orderDetail?.guide_info?.human_auditing_status === 2
                ? "reservation.detail.audit.checked"
                : "house.orderdetail.view"
              ) | translate
            }}
          </a>
        </div>
      </div>
    </div>

    <!-- 押金 -->
    <host-widget-deposit
      *ngIf="orderDetail?.guide_info?.deposit"
      [depositDetail]="orderDetail?.guide_info?.deposit"
      [reservationCode]="orderDetail?.code"
      (onSuccess)="onCompleteEdit.emit()"></host-widget-deposit>
  </div>
</div>
